import styled, { css } from 'styled-components'

export const TopHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 20px;
  background-color: #02e5ff;
  border-bottom: 1px solid #000;

  img {
    height: 90px;
    cursor: pointer;
    object-fit: contain;
    filter: drop-shadow(0 0 1px #0abde3) drop-shadow(0 0 .6px #0abde3);
  }

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    padding: 5px 15px 15px;
    gap: 12px;

    img {
      height: 140px;
      width: 140px;
      object-fit: contain;
      margin-top: -20px;
      margin-left: -40px; /* Adjust to remove internal whitespace of the logo */
    }
  }
`

export const TextNeonPink = styled.div`
  color: #ff0090;
  font-family: 'Bebas Neue', sans-serif;
  font-weight: 400;
  font-size: 1.5rem;
  text-shadow: 0 0 23.1px rgba(255, 0, 144, 0.25), 0 0 40.3px rgba(255, 0, 143, 0.4);
  text-transform: uppercase;
  letter-spacing: 2px;
  text-align: center;
  flex: 1;
  padding: 0 5px;

  @media (max-width: 768px) {
    font-size: 26px;
    font-weight: 200;
    letter-spacing: 0px;
    font-family: 'Bebas Neue', sans-serif;
    text-align: left;
    flex: none;
    width: 100%;
    padding: 0;
    margin-top: -20px;
    line-height: 1.1;
    text-shadow: 0 0 23.1px rgba(255, 0, 144, 0.25), 0 0 40.3px rgba(255, 0, 143, 0.4);
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
`

export const ButtonYellow = styled.button`
  background-color: #fff000;
  color: #000;
  border: none;
  padding: 10px 22px;
  margin-right: 1rem;
  font-weight: 900;
  border-radius: 6px;
  cursor: pointer;
  font-size: 0.8rem;
  float: right;
  transition: all 0.2s ease;
  box-shadow: 0 0 15px rgba(255,240,0,0.8), 0 0 30px rgba(255,240,0,0.4);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  white-space: nowrap;

  @media (max-width: 768px) {
    padding: 12px 25px;
    font-size: 13px;
    margin-top: 10px;
    width: auto;
    float: none;
    border-radius: 10px;
    box-shadow: 0 0 6px rgba(255,240,0,1), 0 0 20px rgba(255,240,0,0.6);
  }

  &:hover {
    transform: scale(1.05);
    box-shadow: 0 0 25px rgba(255,240,0,1);
  }
`

export const CyanBorder = styled.div`
  width: 100%;
  height: 1px;
  background-color: #0abde3;
`

export const AddressBar = styled.div`
  background: #FFF;
  color: #333;
  height: 52px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid #E9ECEF;
  position: sticky;
  top: 0;
  z-index: 10001;
  width: 100%;
  box-sizing: border-box;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);

  @media (min-width: 768px) {
    background: #00feff;
    color: #000;
    height: 60px;
    border-bottom: 2px solid #00feff;
    box-shadow: none;
  }

  span {
    background: #FFF;
    border: 1px solid #E9ECEF;
    padding: 6px 20px;
    border-radius: 50px;
    font-weight: 700;
    text-transform: capitalize;
    color: #333;
    cursor: pointer;
    box-shadow: 0 2px 5px rgba(0,0,0,0.05);
    transition: all 0.3s ease;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 90%;
    font-size: 14px;
    letter-spacing: 0.2px;

    @media (min-width: 768px) {
      background: #02e5ff;
      border: 1.5px solid #00E5FF;
      padding: 8px 30px;
      color: #fff;
      box-shadow: 0 0 15px rgba(0, 229, 255, 0.6);
      font-size: 16px;
      font-weight: 900;
    }

    &:hover {
      box-shadow: 0 0 25px rgba(0, 229, 255, 1);
      transform: translateY(-2px);
      border-color: #00E5FF;
    }
  }

  @media (max-width: 768px) {
    height: 54px;
    span {
      font-size: 0.9rem;
      padding: 6px 20px;
    }
  }
`

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: ${props => props.theme?.header?.components?.style?.backgroundColor};
`

export const InnerHeader = styled.div`
  display: flex;
  width: 100%;
  color: #FFF;
  justify-content: space-between;
  margin: 15px 0;
  align-items: center;

  #left-side {
    width: ${({ theme }) => theme?.header?.components?.layout?.type === 'starbucks' ? '30%' : '25%'};
    justify-content: flex-start;
  }
  #right-side {
    width: ${({ theme }) => theme?.header?.components?.layout?.type === 'starbucks' ? '30%' : '40%'};
    justify-content: flex-end;
  }
  #center-side {
    width: ${({ theme }) => theme?.header?.components?.layout?.type === 'starbucks' ? 'calc(60% - 140px)' : 'calc(60% - 30px)'};
  }

  @media (min-width: 768px) {
    #left-side {
      width: ${({ theme }) => theme?.header?.components?.layout?.type === 'starbucks' ? '30%' : 'initial'};
    }
    #center-side {
      width: calc(100% - 60px);
    }
  }

  @media (min-width: 1024px) {
    #center-side {
      width: calc(100% - 140px);
    }
  }

  @media (min-width: 1200px) {
    #center-side {
      width: calc(70% - 200px);
    }
  }

  @media (min-width: 1500px) {
    #center-side {
      width: calc(60% - 260px);
    }
  }
`
export const LogoHeader = styled.div`
  cursor: pointer;

  img {
    width: ${props => props.imgW ?? '35px'};
    height: ${props => props.imgH ?? '45px'};
    margin: 0;
    vertical-align: middle;
    margin-left: 10px;
    object-fit: contain;

    ${props => props.theme?.rtl && css`
      margin-right: 10px;
      margin-left: 0;
    `}

    @media (min-width: 769px) {
      ${({ theme }) =>
    ['center', 'right']?.includes(theme?.header?.components?.logo?.components?.layout?.position) && css`
        margin-right: 30px;
      `};
      width: ${props => props.imgW ?? '150px'};
    }
  }

  ${props => !props.disabledResponsive && css`
    img:nth-child(1) {
      display: none;
    }
  `}

  @media (min-width: 769px) {
    img:nth-child(1) {
      display: block;
    }
    img:nth-child(2) {
      display: none;
    }
  }
`

export const LeftHeader = styled.div`
  align-self: center;
  display: flex;
  align-items: center;
`

export const RightHeader = styled.div`
  align-self: center;
  display: flex;

  #select-input {
    div {
      color: ${props => props.theme.colors.darkTextColor};
    }
  }
`

export const Menu = styled.div`
  display: flex;
  align-items: center;
  margin-right: 10px;

  #select-input {
    border-radius: 7.6px;

    #list {
      border-radius: 7.6px;
    }

    ${({ isCustomerMode }) => !isCustomerMode && css`
      margin: 0px 5px;
      height: 40px;

      svg {
        font-size: 16px;
      }

      > div:first-child {
        height: 100%;
        padding-left: 10px;
        padding-right: 10px;

        @media (min-width: 993px) {
          padding-left: 13px;
          padding-right: 13px;
        }
      }
    `}
  }

  &.left-header {
    background: #F8F9FA;
    border: none;
    box-sizing: border-box;
    border-radius: 50px;
    margin: 0 15px;
    flex-grow: 1;
    padding: 0 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    height: 44px;

    @media (min-width: 850px) {
      border: 1px solid ${props => props.theme?.colors.darkGray};
      justify-content: space-between;
    }

    @media (min-width: 1024px) {
      margin: 0 20px;
      padding: 0 20px;
      margin-left: 45px;
    }

    @media (min-width: 1200px) {
      padding: 0 30px;
      margin-left: 50px;
    }

    @media (min-width: 1500px) {
      padding: 0 30px;
      margin: 0 75px;
    }
  }

  > span {
    #select-input {
      background: transparent !important;
    }
  }

  .moment-popover {
    border-left: 1px solid ${props => props.theme?.colors.darkGray};
    border-right: 1px solid ${props => props.theme?.colors.darkGray};
    height: 100%;
    justify-content: center;
    width: 200px;
    display: none;

    @media (min-width: 1175px) {
      width: 250px;
    }

    @media (min-width: 1400px) {
      width: 400px;
    }

    > div:first-child {
      width: 100%;
      display: flex;
      justify-content: center;
    }
  }

  .address-popover {
    flex-grow: 1;
    display: none;
    > div:first-child {
      width: 100%;
    }
  }

  .order-type {
    padding: 0 5px;

    @media (min-width: 1300px) {
      padding: 0 20px;
    }
  }


  @media (min-width: 850px) {
    .moment-popover,
    .address-popover {
      display: flex;
    }
  }
`

export const MenuItem = styled.div`
  display: flex;
`

export const MenuLink = styled.a`
  text-decoration: none;
  font-size: 14px;
  padding: 10px;
  color: #333;
  cursor: pointer;
`

export const SubMenu = styled(InnerHeader)`
  display: flex;
  width: 100%;
  justify-content: space-between;
  padding: 0px 20px 7px;
  box-sizing: border-box;
  margin: 0px;
  position: relative;

  @media (min-width: 850px) {
    display: none;
  }
`

export const CustomerInfo = styled.div`
  display: none;
  cursor: pointer;
  flex: 1;
  position: relative;
  @media (min-width: 450px) {
    display: flex;
    justify-content: center;
    align-items: center;

    span {
      display: flex;
      align-items: center;
      margin: 0;
      p {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        color: ${props => props.theme?.colors.darkGray};
      }
      svg {
        color: #748194;
        margin: 0;
        font-size: 20px;
        position: absolute;
        right: 0;
      }
    }
  }
`

export const UserEdit = styled.div`
  > :first-child{
     margin-bottom: 20px;
  }
`

export const AddressMenu = styled.div`
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  color: ${props => props.theme.colors?.headingColor};
  display: flex;
  align-items: center;
  position: relative;

  span {
    width: 85%;
    p {
      margin: 0;
      padding: 0;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }
  }

  ${({ isCustomerMode }) => isCustomerMode
    ? css`
    flex: 0.8;
  `
    : css`
    width: 50%;
  `}

  svg {
    color: ${props => props.theme.colors?.lightGray};
    font-size: 16px;
    margin-right: 10px;
    ${props => props.theme?.rtl && css`
      margin-left: 10px;
      margin-right: 0;
    `}
  }
  @media (min-width: 765px) {
    ${({ isCustomerMode }) => !isCustomerMode && css`
      width: 80%;
    `}
  }
  @media (min-width: 820px) {
    ${({ isCustomerMode }) => !isCustomerMode && css`
      width: 50%;
    `}
  }
`

export const MomentMenu = styled.div`
  border-left: 1px solid ${props => props.theme?.colors.darkGray};
  ${({ $isFranchiseSlugOne }) => !$isFranchiseSlugOne && css`
      border-right: 1px solid ${props => props.theme?.colors.darkGray};
  `}
  height: 100%;
  justify-content: center;
  width: 175px;
  display: none;

  @media (min-width: 850px) {
    display: flex;
  }

  @media (min-width: 1175px) {
    width: 250px;
  }

  @media (min-width: 1400px) {
    width: 400px;
  }

  > div {
    cursor: pointer;
    font-size: 14px;
    color: ${props => props.theme?.colors.darkGray};
    display: flex;
    align-items: center;
    text-align: center;
    white-space: nowrap;
    padding: 0 10px;
  }
`

export const FarAwayMessage = styled.div`
  pointer-events: none;
  position: absolute;
  display: flex;
  align-items: center;
  z-index: 2000;
  top: 100%;
  background: ${props => props.theme.colors.warning100};
  border: 1px solid ${props => props.theme.colors.warning500};
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.12);
  border-radius: 7.6px;
  padding: 6px 15px;
  box-sizing: border-box;
  margin: 10px 0px 0px 0px !important;

  left: 5px;
  ${props => props.theme?.rtl && css`
    right: 5px;
    left: initial;
  `}

  svg {
    font-size: 20px;
    color: ${props => props.theme.colors.warning500};
    margin-right: 10px;
    ${props => props.theme?.rtl && css`
      margin-right: auto;
      margin-left: 10px;
    `}
  }
  span {
    font-size: 12px;
    line-height: 18px;
    color: ${props => props.theme.colors.headingColor};
  }

  @media (min-width: 400px) {
    padding: 8px 20px;
    font-size: 14px;
    line-height: 24px;
    left: 10px;
    ${props => props.theme?.rtl && css`
      right: 10px;
      left: initial;
    `}
  }
`

export const Divider = styled.div`
  border: 1px solid ${props => props.theme?.colors.darkGray};
  height: 100%;
`
export const AddressFormWrapper = styled.div`
  @media (min-width: 450px) {
    margin-top: 20px;
  }
`
export const InputGroup = styled.div`
  p {
    font-weight: 500;
    font-size: 20px;
    color: ${props => props.theme.colors.darkTextColor};
    width: 100%;
    text-align: left;
    margin: 0 0 7px 0;
  }
`

export const LanguageSelectorWrapper = styled(InputGroup)`
  > div {
    border-radius: 7.6px;
    text-align: left;
    background: #F8F9FA !important;
    border-color: #F8F9FA;
    background-color: #F8F9FA !important;
    height: 44px;

    > div:first-child {
      height: 44px;
    }

    #list {
      border-radius: 7.6px;
      background: #F8F9FA !important;
      border-color: #F8F9FA;
    }
  }
  #select-input {
    margin-left: 5px;
  }
`

export const CurrencySelectorWrapper = styled(InputGroup)`
  > div {
    border-radius: 7.6px;
    text-align: left;
    background: #F8F9FA !important;
    border-color: #F8F9FA;
    background-color: #F8F9FA !important;
    height: 44px;
    min-width: 80px;

    > div:first-child {
      height: 44px;
    }

    #list {
      border-radius: 7.6px;
      background: #F8F9FA !important;
      border-color: #F8F9FA;
    }
  }
  #select-input {
    margin-left: 5px;
  }
`

export const HeaderSearchMode = styled.div`
  display: flex;
  justify-content: center;
  width: 300px;
  a {
    text-decoration: none;
  }
  input {
    overflow: hidden;
    text-overflow: ellipsis;
  }
  @media (min-width: 1400px){
    width: 350px;
  }
  @media (min-width: 1200px){
    width: 300px;
    div {
      > span {
        padding: 7px 0;
      }
    }
  }
`

export const LeftSide = styled.div`
  display: flex;
  width: 100%;
  @media (min-width: 769px){
    flex-direction: ${({ theme }) =>
    ['center', 'right']?.includes(theme?.header?.components?.logo?.components?.layout?.position) ? 'row-reverse' : 'row'};
    width: 62%;
  }
`
